module.exports = __webpack_public_path__ + "img/yanni.8fac829a.jpg";